import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCubes } from "@fortawesome/free-solid-svg-icons";

const StarIcon = ({ className = "fill-[#0971A2]" }) => (
    <FontAwesomeIcon icon={faCubes} className={className} />
);
export default StarIcon;
